import { forwardRef } from "react";
import { SxProps } from "@mui/material";

type ModelContainerProps = {
  size: "sm" | "md" | "lg" | "xl" | "auto" | "full";
  sx?: SxProps;
};

const widthMap: Record<ModelContainerProps["size"], string> = {
  sm: "411px",
  md: "500px",
  lg: "600px",
  xl: "700px",
  auto: "auto",
  full: "100%",
};

const DEFAULT_SIZE = "sm";

const withModelContainer = <P extends object>(ModalContainerComponent: React.ComponentType<P>) => {
  return forwardRef<any, React.PropsWithChildren<P & ModelContainerProps>>(
    ({ size = DEFAULT_SIZE, children, ...props }, ref) => {
      const { sx, ...rest } = props;

      return (
        <ModalContainerComponent
          ref={ref}
          sx={{
            ...sx,
            maxWidth: widthMap[size],
            width: widthMap[size],
          }}
          {...(rest as P)}>
          {children}
        </ModalContainerComponent>
      );
    },
  );
};

export { withModelContainer, type ModelContainerProps };
